import { useTheme } from "@mui/material"
import { useContextState } from "../../../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    const { breakpoints } = useTheme()
    return {
        container: {
            width: '100%',
            height: '100%',
            paddingTop: '50px',
            paddingRight: '50px',
            paddingBottom: '10px',
            overflowY: 'auto',
            overflowX: 'hidden',
            position: 'relative',
            paddingLeft: '30px',
        },
        containerForms: {
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 3,
            '& .child': {
                [breakpoints.up('lg')]: {
                    width: '300px'
                },
                [breakpoints.down('lg')]: {
                    width: '400px'
                },
            }
        },
        body: {
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            marginTop: 3
        },
        buttonsContainer: {
            marginTop: 3,
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            '& .back': {
                width: '80px',
                height: '36px',
                textTransform: 'uppercase',
            },
            '& .next': {
                borderRadius: '4px',
                textTransform: 'uppercase',
            },
        },
    }
}

export { useStyles }